<router-outlet></router-outlet>

<p-blockUI [blocked]="true" *ngIf="loader.loading$ | async">
  <div class="w-full h-full flex items-center justify-center">
    <p-progressSpinner
      strokeWidth="4"
      fill="transparent"
      animationDuration=".5s"
      [style]="{ width: '50px', height: '50px' }"
    />
  </div>
</p-blockUI>
<notifier-container></notifier-container>
